import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AESLogo from '../../assets/AES_short_white.svg';

// Mapping von Pfaden auf Titel
const pathMapping = {
    '/dashboard': { parent: 'ADE', title: 'Dashboard' },
    '/eventImport': { parent: 'Einsatzplanung', title: 'Event-Import' },
    '/plantafel': { parent: 'Einsatzplanung', title: 'Plantafel' },
    '/eventmatching': { parent: 'Einsatzplanung', title: 'Auswahl' },
    '/personal': { parent: 'ADE', title: 'Personal' },
    '/personal/import': { parent: 'ADE', title: 'Personal Import' },
    '/personal/forecast': { parent: 'Personal', title: 'Prognose' },
    '/leistungspaketeAuswahl': { parent: 'Leistungspakete', title: 'Auswahl' },
    '/leistungspakete': { parent: 'Leistungspakete', title: 'Übersicht' },
    '/leistungspakete/ADEC': { parent: 'Leistungspakete', title: 'ADEC' },
    '/leistungspakete/GROS_DOLLN': { parent: 'Leistungspakete', title: 'Groß Dölln' },
    '/leistungspakete/TOUREN': { parent: 'Leistungspakete', title: 'Touren' },
    '/leistungspakete/ASCE': { parent: 'Leistungspakete', title: 'ASCE' },
    '/leistungspakete/FINNLAND': { parent: 'Leistungspakete', title: 'Finnland' },
    '/leistungspakete/SEEFELD': { parent: 'Leistungspakete', title: 'Seefeld' },
    '/leistungspakete/SAALBACH': { parent: 'Leistungspakete', title: 'Saalbach' },
    '/leistungspakete/ADE': { parent: 'Leistungspakete', title: 'ADE' },
    '/leistungspakete/NICHT_EVENT': { parent: 'Leistungspakete', title: 'Nicht-Eventeinsätze' },
    '/leistungspakete/import': { parent: 'Leistungspakete', title: 'Import' },
    '/stundenkontingenteAuswahl': { parent: 'Stundenkontingente', title: 'Auswahl' },
    '/stundenkontingente': { parent: 'Stundenkontingente', title: 'Export' },
    '/stundenkontingente/import': { parent: 'Stundenkontingente', title: 'Import' },
    '/riskmanagement': { parent: 'ADE', title: 'Riskmanagement' },
};

const TopNavbar = ({ onBurgerClick }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout } = useAuth();
    const logoutRef = useRef(null);


    // 🔍 Titel aus Pfad berechnen
    const currentPath = location.pathname;
    const pageInfo = pathMapping[currentPath] || { parent: 'ADE', title: 'Dashboard' };

    return (
        <div className="bg-gray-100 border-b shadow-sm">
            <div className="w-full px-5 sm:px-5 lg:px-6">
                <div className="flex justify-between items-center h-16">
                    {/* Left Section */}
                    <div className="flex items-center space-x-3">
                        <button
                            onClick={() => onBurgerClick && onBurgerClick()}
                            className="text-black"
                        >
                            <svg
                                className="w-8 h-8"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16m-7 6h7"
                                />
                            </svg>
                        </button>
                        <div className="flex flex-col leading-tight">
                            <span className="text-sm text-gray-500">{pageInfo.parent}</span>
                            <span className="text-lg font-semibold text-black">{pageInfo.title}</span>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="flex items-center space-x-4 relative">
                        <img src={AESLogo} alt="AES Logo" className="h-12 invert" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopNavbar;
